/*!
 * devextreme-angular-test
 * Version: 17.2.8
 * Build date: Mon Feb 05 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';


import DevExpress from 'devextreme/bundles/dx.all';

import { NestedOptionHost } from '../../core/nested-option';
import { CollectionNestedOption } from '../../core/nested-option';



export class DxiLayerComponent extends CollectionNestedOption {
    
    get borderColor(): string {
        return this._getOption('borderColor');
    }
    set borderColor(value: string) {
        this._setOption('borderColor', value);
    }

    
    get borderWidth(): number {
        return this._getOption('borderWidth');
    }
    set borderWidth(value: number) {
        this._setOption('borderWidth', value);
    }

    
    get color(): string {
        return this._getOption('color');
    }
    set color(value: string) {
        this._setOption('color', value);
    }

    
    get colorGroupingField(): string {
        return this._getOption('colorGroupingField');
    }
    set colorGroupingField(value: string) {
        this._setOption('colorGroupingField', value);
    }

    
    get colorGroups(): Array<number> {
        return this._getOption('colorGroups');
    }
    set colorGroups(value: Array<number>) {
        this._setOption('colorGroups', value);
    }

    
    get customize(): Function {
        return this._getOption('customize');
    }
    set customize(value: Function) {
        this._setOption('customize', value);
    }

    
    get data(): any|
        DevExpress.data.DataSource|
        DevExpress.data.DataSourceOptions {
        return this._getOption('data');
    }
    set data(value: any|
        DevExpress.data.DataSource|
        DevExpress.data.DataSourceOptions) {
        this._setOption('data', value);
    }

    
    get dataField(): string {
        return this._getOption('dataField');
    }
    set dataField(value: string) {
        this._setOption('dataField', value);
    }

    
    get dataSource(): any|
        DevExpress.data.DataSource|
        DevExpress.data.DataSourceOptions|
        string {
        return this._getOption('dataSource');
    }
    set dataSource(value: any|
        DevExpress.data.DataSource|
        DevExpress.data.DataSourceOptions|
        string) {
        this._setOption('dataSource', value);
    }

    
    get elementType(): string {
        return this._getOption('elementType');
    }
    set elementType(value: string) {
        this._setOption('elementType', value);
    }

    
    get hoveredBorderColor(): string {
        return this._getOption('hoveredBorderColor');
    }
    set hoveredBorderColor(value: string) {
        this._setOption('hoveredBorderColor', value);
    }

    
    get hoveredBorderWidth(): number {
        return this._getOption('hoveredBorderWidth');
    }
    set hoveredBorderWidth(value: number) {
        this._setOption('hoveredBorderWidth', value);
    }

    
    get hoveredColor(): string {
        return this._getOption('hoveredColor');
    }
    set hoveredColor(value: string) {
        this._setOption('hoveredColor', value);
    }

    
    get hoverEnabled(): boolean {
        return this._getOption('hoverEnabled');
    }
    set hoverEnabled(value: boolean) {
        this._setOption('hoverEnabled', value);
    }

    
    get label(): any {
        return this._getOption('label');
    }
    set label(value: any) {
        this._setOption('label', value);
    }

    
    get maxSize(): number {
        return this._getOption('maxSize');
    }
    set maxSize(value: number) {
        this._setOption('maxSize', value);
    }

    
    get minSize(): number {
        return this._getOption('minSize');
    }
    set minSize(value: number) {
        this._setOption('minSize', value);
    }

    
    get name(): string {
        return this._getOption('name');
    }
    set name(value: string) {
        this._setOption('name', value);
    }

    
    get opacity(): number {
        return this._getOption('opacity');
    }
    set opacity(value: number) {
        this._setOption('opacity', value);
    }

    
    get palette(): string|
        Array<string> {
        return this._getOption('palette');
    }
    set palette(value: string|
        Array<string>) {
        this._setOption('palette', value);
    }

    
    get paletteSize(): number {
        return this._getOption('paletteSize');
    }
    set paletteSize(value: number) {
        this._setOption('paletteSize', value);
    }

    
    get selectedBorderColor(): string {
        return this._getOption('selectedBorderColor');
    }
    set selectedBorderColor(value: string) {
        this._setOption('selectedBorderColor', value);
    }

    
    get selectedBorderWidth(): number {
        return this._getOption('selectedBorderWidth');
    }
    set selectedBorderWidth(value: number) {
        this._setOption('selectedBorderWidth', value);
    }

    
    get selectedColor(): string {
        return this._getOption('selectedColor');
    }
    set selectedColor(value: string) {
        this._setOption('selectedColor', value);
    }

    
    get selectionMode(): string {
        return this._getOption('selectionMode');
    }
    set selectionMode(value: string) {
        this._setOption('selectionMode', value);
    }

    
    get size(): number {
        return this._getOption('size');
    }
    set size(value: number) {
        this._setOption('size', value);
    }

    
    get sizeGroupingField(): string {
        return this._getOption('sizeGroupingField');
    }
    set sizeGroupingField(value: string) {
        this._setOption('sizeGroupingField', value);
    }

    
    get sizeGroups(): Array<number> {
        return this._getOption('sizeGroups');
    }
    set sizeGroups(value: Array<number>) {
        this._setOption('sizeGroups', value);
    }

    
    get type(): string {
        return this._getOption('type');
    }
    set type(value: string) {
        this._setOption('type', value);
    }

    protected get _optionPath() {
        return 'layers';
    }


    constructor(  parentOptionHost: NestedOptionHost,
             optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'dxi-layer',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }, ]},
{type: NestedOptionHost, decorators: [{ type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'borderColor': [{ type: Input },],
'borderWidth': [{ type: Input },],
'color': [{ type: Input },],
'colorGroupingField': [{ type: Input },],
'colorGroups': [{ type: Input },],
'customize': [{ type: Input },],
'data': [{ type: Input },],
'dataField': [{ type: Input },],
'dataSource': [{ type: Input },],
'elementType': [{ type: Input },],
'hoveredBorderColor': [{ type: Input },],
'hoveredBorderWidth': [{ type: Input },],
'hoveredColor': [{ type: Input },],
'hoverEnabled': [{ type: Input },],
'label': [{ type: Input },],
'maxSize': [{ type: Input },],
'minSize': [{ type: Input },],
'name': [{ type: Input },],
'opacity': [{ type: Input },],
'palette': [{ type: Input },],
'paletteSize': [{ type: Input },],
'selectedBorderColor': [{ type: Input },],
'selectedBorderWidth': [{ type: Input },],
'selectedColor': [{ type: Input },],
'selectionMode': [{ type: Input },],
'size': [{ type: Input },],
'sizeGroupingField': [{ type: Input },],
'sizeGroups': [{ type: Input },],
'type': [{ type: Input },],
};
}


export class DxiLayerModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    DxiLayerComponent
  ],
  exports: [
    DxiLayerComponent
  ],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
